<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <!-- Search -->
          <b-col cols="12" lg="9">
            <b-row class="align-items-center">
              <b-col lg="6" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model.trim="searchQuery"
                    class="d-inline-block round"
                    :placeholder="$t('textPlaceholderSearchUser')"
                  />
                </div>
              </b-col>
              <b-col cols="12" md="6" lg="6" class="d-flex p-0 my-1 m-lg-0">
                <div class="justify-content-center d-flex" style="width: 80%">
                  <flat-pickr
                    v-model="searchQuerys"
                    :config="config"
                    type="date"
                    class="form-control flat-picker bg-transparent shadow-none"
                    :placeholder="$t('date_selected')"
                  ></flat-pickr>
                  <!-- <flat-pickr
                v-model="rangePicker"
                :config="config"
                class="
                  form-control
                  flat-picker
                  bg-transparent
                  border-0
                  shadow-none
                "
                placeholder="YYYY-MM-DD"
              /> -->
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="3">
            <!-- datepicker -->

            <b-button
              class="round px-5"
              variant="primary"
              :disabled="
                searchQuery ? false : true && searchQuerys ? false : true
              "
              @click="onSearch"
            >
              {{ $t("search") }}
            </b-button>
          </b-col>
        </b-row>
      </div>

      <p class="ml-2" style="font-weight: 600">
        <span>{{ $t("total_quotation") }}:</span>
        {{ totalQuotation }}
        <span class="ml-2">{{ $t("total_booking") }}:</span>
        {{ totalBooking }}
      </p>
      <b-table
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        responsive
        hover
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      ></b-table>
    </b-card>
    <b-row class="pl-2 pr-2 pb-1 pt-1 border-top">
      <b-col
        cols="12"
        md="6"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <label>{{ $t("showing") }} </label>
        <v-select
          v-model="perPage"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="perPageOptions"
          :clearable="false"
          style="min-width: 60px"
          class="per-page-selector select-size-sm d-inline-block ml-50 mr-1"
        />
        <label>{{ $t("entries") }}</label>
      </b-col>
      <b-col
        cols="12"
        md="6"
        class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
      >
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="totalRows"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

import vSelect from "vue-select";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import moment from "moment";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import router from "@/router";
import { Utils } from "@/@core/utils/utilsCustom";

export default {
  components: {
    moment,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    FeatherIcon,
    ValidationProvider,
    ValidationObserver,
    router,
    ToastificationContent,
    useJwt,
  },
  data() {
    return {
      sortBy: "total_quotation",
      sortDesc: true,
      totalBooking: 0,

      totalQuotation: 0,
      searchQuery: "",
      searchQuerys: "",
      rangePicker: ["", ""],
     config : {
        mode: "range",
        altFormat: "d-m-Y",
        altInput: true,
      },
      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      fields: [],
      items: [],
      startDate: "",
      endDate: "",
    };
  },
  methods: {
    fetchUser: function () {
      this.$loading.show();
      useJwt
        .get("wr1?objectType=MyWR1ByQuotationAndBooking_CreatedBySale", {
          params: {
            search: {
              startDate: this.startDate,
              endDate: this.endDate,
              quotationStatus: Utils.CONSTANTS.STATUS_WR1.QUOTATION,
              bookingStatus: Utils.CONSTANTS.STATUS_WR1.BOOKING,
            },
          },
        })
        .then((response) => {
          this.items = response.data.result;
          var t = 0;
          var b = 0;
          response.data.result.map((e) => {
            t += e.total_quotation;
            b += e.total_booking;
          });
          this.totalRows = this.items.length;
          this.totalQuotation = t;
          this.totalBooking = b;
        })
        .catch((error) => {
          this.$loading.hide();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
    onSearch() {
      if (this.searchQuery != null) {
        let arr_items = this.items;
        let search_q = this.searchQuery;
        let search_item = arr_items.filter((sarr_item, index, array) => {
          let jkl = sarr_item.id.toLowerCase();
          return jkl.indexOf(search_q) > -1;
        });
        this.items = search_item;
      }
      let search_qs = this.searchQuerys;
      if (search_qs != "") {
        if (search_qs.length > 15) {
          let startDate_ = search_qs.slice(0, 10);
          let endDate_ = search_qs.slice(14, 24);

          this.startDate = moment(startDate_).format("DD/MM/YYYY");
          this.endDate = moment(endDate_).format("DD/MM/YYYY");
          this.fetchUser();
        } else {
          this.startDate = moment(search_qs).format("DD/MM/YYYY");
          this.fetchUser();
        }
      }
    },
  },
  watch: {
    searchQuery: function (n, o) {
      if (this.searchQuery == "") {
        this.fetchUser();
      }
    },

    "$i18n.locale": function (newVal, oldVal) {
      this.renderComponent = false;
      this.fields = [];
      this.$nextTick(() => {
        // Add the component back in
        this.fields = [
          {
            key: "full_name",
            sortable: false,
            label: this.$i18n.t("salesman"),
            tdClass: "text-left",
          },
          {
            key: "total_quotation",
            sortable: false,
            label: this.$i18n.t("total_quotation"),
          },
          {
            key: "total_booking",
            sortable: false,
            label: this.$i18n.t("total_booking"),
          },
        ];

        this.renderComponent = true;
      });
    },
  },
  mounted() {
    this.fetchUser();

    this.fields = [
      {
        key: "full_name",
        sortable: false,
        label: this.$i18n.t("salesman"),
        tdClass: "text-left",
      },
      {
        key: "total_quotation",
        sortable: false,
        label: this.$i18n.t("total_quotation"),
        tdClass: "w200",
      },
      {
        key: "total_booking",
        sortable: false,
        label: this.$i18n.t("total_booking"),
        tdClass: "w200",
      },
    ];
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.flat-picker {
  // width:120%;
  border-radius: 50px;
}
</style>
